/**
 * fanola.hair: "Added to basket" toast "Developers" button -> pop-out.
 *
 * Ported from HDS shopify/assets/cart-dev-popout.js (7d95c07). Spec:
 * docs/superpowers/specs/2026-10-12-fanola-developer-popout-design.md (parent repo), §10.
 *
 * The button sits in the toast ([data-cn-dev], snippets/cart-notification.liquid) when the line
 * just added is a colour/bleach in assets/developer-map.json and the basket holds no developer
 * at all. The pop-out offers that line's own Fanola developer: strength chips, sizes, a
 * stock-bounded quantity, full retail price. The toast is held open while the pop-out is up.
 *
 * Dropped vs HDS: tier prices; the cross-brand "other peroxide" toggle (Violet Peroxide's
 * 5/25 vol never matches a strength chip); the A/B gate.
 */
(function () {
  'use strict';

  function pairFor(map, handle) {
    if (!map || !map.pairs || !handle) return null;
    return map.pairs[handle] || null;
  }

  function ratioMult(ratio) {
    var parts = String(ratio || '').split(':');
    var mult = parts.length === 2 ? parseFloat(parts[1]) / parseFloat(parts[0]) : NaN;
    return isNaN(mult) ? null : mult;
  }

  function sizeMl(title) { var m = /(\d+)\s*ml\b/i.exec(title || ''); return m ? parseInt(m[1], 10) : null; }

  /**
   * Developer the WHOLE basket needs for one developer family: every colour line whose pair
   * points at that family counts, each at its own ratio and tube size. ml is null when any
   * counted line has no stated ratio or no ml size - the copy then states the ratio only
   * rather than inventing a total.
   */
  function basketNeed(map, items, familyId) {
    var tubes = 0, ml = 0, known = true, ratios = {};
    (items || []).forEach(function (it) {
      var pair = it && pairFor(map, it.handle);
      if (!pair || pair.developer !== familyId) return;
      var q = Number(it.quantity) || 0;
      if (!q) return;
      tubes += q;
      ratios[pair.ratio || ''] = true;
      var mult = ratioMult(pair.ratio), size = sizeMl(it.product_title);
      if (mult === null || !size) known = false;
      else ml += q * size * mult;
    });
    var rs = Object.keys(ratios);
    return { tubes: tubes, ml: (tubes && known) ? Math.round(ml) : null,
             ratio: rs.length === 1 && rs[0] ? rs[0] : null };
  }

  /** Starting quantity for one row: enough of THIS size to cover the need. 1 when unknown. Max 99. */
  function suggestQty(needMl, sizeLabel) {
    var t = String(sizeLabel || '').toLowerCase();
    var m = /(\d+(?:\.\d+)?)\s*(ml|l|litre|liter)\b/.exec(t);
    var size = m ? parseFloat(m[1]) * (m[2] === 'ml' ? 1 : 1000) : null;
    if (!needMl || !size) return 1;
    return Math.max(1, Math.min(99, Math.ceil(needMl / size)));
  }

  /** need: basketNeed() result; null when the basket read failed (falls back to the pair's ratio). */
  function buttonCopy(pair, need) {
    var ratio = (need && need.tubes) ? need.ratio : pair.ratio;
    var ml = need && need.ml;
    var sub;
    if (ml && ratio) sub = 'Mixes ' + ratio + ' — your basket needs ' + ml + 'ml';
    else if (ml) sub = 'Your basket needs ' + ml + 'ml of developer';
    else if (ratio) sub = 'Mixes ' + ratio;
    else sub = 'Developer for ' + (pair.colour_name || 'your colour');
    return { title: 'Developers', sub: sub };
  }

  /** The button is earned only when the matching family has a strength in stock right now. */
  function barEarned(dev, m, pair, prods) {
    if (!dev || !m || !pair || !m.families || !m.families[pair.developer]) return false;
    var o = dev.developerOffer(m, pair.developer, prods || {}, { defaultStrength: pair.default_strength });
    return !!(o && o.strengths.length);
  }

  window.CartDevPopout = { pairFor: pairFor, basketNeed: basketNeed, suggestQty: suggestQty,
                           buttonCopy: buttonCopy, barEarned: barEarned };
  if (typeof document === 'undefined' || !document.addEventListener) return;

  var K = window.UpsellKit, D = window.CartDeveloperUpsell;
  var mapP = null, cache = {}, bar = null, current = null, lastFocus = null, evalSeq = 0, opening = false;
  var st = { strength: null, added: {}, qty: {}, busy: {} };
  var escConsumed = false;

  function json(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function box() { return document.getElementById('dev-popout'); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function product(h) { return cache[h] || (cache[h] = json('/products/' + encodeURIComponent(h) + '.js')); }
  function map() {
    if (mapP) return mapP;
    var b = box(), url = b && b.getAttribute('data-map-url');
    mapP = url ? json(url) : Promise.resolve(null);
    return mapP;
  }
  function toast() { return document.querySelector('cart-notification'); }
  function devSlot() { return document.querySelector('[data-cn-dev]'); }

  /**
   * The toast opened for an add: decide whether it earns a Developers button. Earned when the
   * line just added is a colour/bleach in the map, the basket holds no developer at all (§8.3),
   * and that line's developer family has a strength in stock. The need is the whole basket's.
   * Only `bar` is written here - an open pop-out session (`current`) is never touched.
   */
  function onToastOpen(e) {
    var b = box();
    if (b && !b.hidden) return;   // the toast repainting for a developer this pop-out just added
    var s = devSlot();
    if (!s) return;
    s.hidden = true; s.innerHTML = ''; bar = null;
    var seq = ++evalSeq;
    var item = e && e.detail && e.detail.item;
    if (!K || !D || !item || !item.handle) return;
    Promise.all([map(), json('/cart.js')]).then(function (r) {
      var m = r[0], cart = r[1];
      if (!m || !cart || seq !== evalSeq) return null;
      var pair = pairFor(m, item.handle);
      if (!pair || !m.families || !m.families[pair.developer]) return null;
      if (!D.pick(cart.items, m)) return null;   // a developer is already in the basket
      var hs = D.offerHandles(m, pair.developer, false);
      return Promise.all(hs.map(product)).then(function (ps) {
        var prods = {};
        hs.forEach(function (h, i) { prods[h] = ps[i]; });
        if (!barEarned(D, m, pair, prods)) return null;
        return { map: m, pair: pair, colourHandle: item.handle, need: basketNeed(m, cart.items, pair.developer) };
      });
    }).then(function (o) {
      var s2 = devSlot();
      if (!o || seq !== evalSeq || !s2) return;
      var copy = buttonCopy(o.pair, o.need);
      bar = { map: o.map, pair: o.pair, colourHandle: o.colourHandle, copy: copy, needMl: o.need && o.need.ml };
      s2.innerHTML = '<button type="button" class="dvb" data-cn-dev-open aria-haspopup="dialog">' +
        '<span class="dvb__t">' + K.esc(copy.title) + '</span><span class="dvb__s">' + K.esc(copy.sub) +
        '</span><span aria-hidden="true">›</span></button>';
      s2.hidden = false;
    });
  }

  function maxOf(id) { return K.capFor(current.stock[id], current.inCart[id]); }

  function setBusy(on) {
    var bb = document.querySelector('[data-cn-dev-open]');
    if (!bb) return;
    if (on) { bb.setAttribute('aria-busy', 'true'); if (bb.classList) bb.classList.add('dvb--busy'); }
    else { bb.removeAttribute('aria-busy'); if (bb.classList) bb.classList.remove('dvb--busy'); }
  }

  function open() {
    if (!bar || !box() || opening) return;
    opening = true;
    setBusy(true);
    lastFocus = document.activeElement;
    current = Object.assign({}, bar, { reserved: null, placed: false, addedAny: false });
    st = { strength: null, added: {}, qty: {}, busy: {} };
    var hs = D.offerHandles(current.map, current.pair.developer, false);
    Promise.all([Promise.all(hs.map(product)), Promise.all(hs.map(K.fetchStock)), json('/cart.js')]).then(function (all) {
      opening = false;
      setBusy(false);   // every path below either shows the pop-out or bails
      if (!current) return;
      var ps = all[0], ss = all[1], cart = all[2];
      current.stock = {}; current.inCart = {};
      ss.forEach(function (m) { for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) current.stock[k] = m[k]; });
      ((cart && cart.items) || []).forEach(function (it) {
        current.inCart[it.variant_id] = (current.inCart[it.variant_id] || 0) + (it.quantity || 0);
      });
      // A variant whose remaining stock is already all in the basket can't be added: treat it
      // as out of stock so it never gets a row or a chip.
      var prods = {};
      hs.forEach(function (h, i) {
        var p = ps[i];
        prods[h] = p ? Object.assign({}, p, { variants: (p.variants || []).map(function (v) {
          return Object.assign({}, v, { available: !!v.available && maxOf(v.id) > 0 });
        }) }) : null;
      });
      current.prods = prods;
      current.offer = D.developerOffer(current.map, current.pair.developer, prods,
        { includeOthers: false, defaultStrength: current.pair.default_strength });
      if (!current.offer || !current.offer.strengths.length) { current = null; return; }
      st.strength = current.offer.defaultStrength;
      var t = toast(); if (t && t.hold) t.hold(true);   // no auto-dismiss while the pop-out is up
      box().hidden = false;   // visible BEFORE draw(): reserve() measures real heights
      draw();
      document.body.classList.add('dev-popout-open');
      var first = box().querySelector('button');
      if (first) first.focus();
    }, function () { opening = false; setBusy(false); });
  }

  function close() {
    var b = box(); if (!b) return;
    b.hidden = true;
    document.body.classList.remove('dev-popout-open');
    var added = current && current.addedAny;
    current = null;
    var tn = toast(); if (tn && tn.hold) tn.hold(false);
    if (added) {   // a developer is in the basket now: the button has done its job
      var s = devSlot();
      if (s) { s.hidden = true; s.innerHTML = ''; }
      bar = null;
    }
    var t = lastFocus && lastFocus.isConnected && lastFocus.offsetParent !== null ? lastFocus : null;
    if (!t) {
      var bb = document.querySelector('[data-cn-dev-open]');
      if (bb && bb.offsetParent !== null) t = bb;
      else {
        // Not the toast's x: focus inside the toast pins it open (focusin = interacting).
        var ae = tn && tn.activeElement;
        t = (ae && ae.isConnected && ae.offsetParent !== null) ? ae : null;
      }
    }
    if (t && t.focus) t.focus();
    else {
      var cur = document.activeElement;
      if (cur && cur !== document.body && cur.blur) cur.blur();
    }
  }

  function refocus(sel) {
    var b = box(), el = sel && b ? b.querySelector(sel) : null;
    if (el && !el.disabled) el.focus();
    else if (b) { var f = b.querySelector('button:not([disabled])'); if (f) f.focus(); }
  }

  function thumb(src) { return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2'); }

  function qtyOf(key, size) {
    if (!st.qty[key]) st.qty[key] = Math.max(1, Math.min(suggestQty(current.needMl, size), maxOf(key)));
    return st.qty[key];
  }

  function row(r) {
    var key = String(r.variantId);
    var done = !!st.added[key];
    var busy = !!st.busy[key];
    var p = current.prods[r.handle] || {};
    return '<div class="dvp__row">' +
      (p.featured_image ? '<img class="dvp__img" src="' + K.esc(thumb(p.featured_image)) + '" alt="" width="40" height="40" loading="lazy">' : '<span class="dvp__img"></span>') +
      '<div class="dvp__lbl">' + K.esc(r.strength + ' · ' + r.size) + '</div>' +
      '<span class="dvp__price">' + K.esc(K.money(r.price)) + '</span>' +
      K.stepperHtml('dvp', key, qtyOf(key, r.size), maxOf(key)) +
      '<button type="button" class="dvp__add' + (done ? ' dvp__add--done' : '') + (busy ? ' dvp__add--busy' : '') + '" data-dvp-add="' + K.esc(key) + '"' +
      (busy ? ' aria-busy="true"' : '') + (done || busy ? ' disabled' : '') + '>' +
      (busy ? '<span class="dvp__spin" aria-hidden="true"></span><span class="dvp__vh">Adding</span>' : (done ? '✓ Added' : 'Add')) + '</button></div>';
  }

  function group(rows) {
    if (!rows.length) return '';
    return '<div class="dvp__grp"><div class="dvp__gh"><span class="dvp__gt">' + K.esc(current.offer.label) + '</span>' +
      '<span class="dvp__badge">Matches your colour</span></div>' + rows.map(row).join('') + '</div>';
  }

  /** Change one row's quantity in place: no redraw, so focus and layout never move. */
  function bump(key, delta) {
    var max = maxOf(key);
    if (max < 1) return;
    var q = K.clampQty(st.qty[key] || 1, delta, max);
    st.qty[key] = q;
    K.syncStepper(box(), 'dvp', key, q, max);
    var add = box().querySelector('[data-dvp-add="' + key + '"]');
    if (add && st.added[key]) { st.added[key] = false; add.disabled = false; add.className = 'dvp__add'; add.textContent = 'Add'; }
  }

  /**
   * No layout shift: once per open, render the rows for EVERY strength into an invisible
   * measurer at the real width and reserve the tallest. A chip click never resizes the pop-out.
   */
  function reserve(body, o) {
    if (current.reserved !== null) return current.reserved;
    var m = document.createElement('div');
    m.className = 'dvp__measure';
    m.setAttribute('aria-hidden', 'true');
    body.appendChild(m);
    var h = 0;
    o.strengths.forEach(function (s) {
      m.innerHTML = group(o.rows(s));
      h = Math.max(h, Math.ceil(m.getBoundingClientRect().height));
    });
    body.removeChild(m);
    current.reserved = h;
    return h;
  }

  /** Desktop: centre vertically once per open, never re-centre. Mobile: bottom sheet (CSS). */
  function place(body) {
    if (current.placed) return;
    current.placed = true;
    if (window.innerWidth < 768) { box().style.paddingTop = ''; return; }
    box().style.paddingTop = Math.max(24, Math.round((window.innerHeight - body.scrollHeight) / 2)) + 'px';
  }

  /** The sub line only when it says more than the heading ("Developer for X" repeats it). */
  function showSub() {
    var sub = current.copy && current.copy.sub;
    return !!sub && sub !== 'Developer for ' + (current.pair.colour_name || 'your colour');
  }

  function draw() {
    var o = current.offer;
    var chips = o.strengths.map(function (s) {
      return '<button type="button" class="dvp__chip" data-dvp-strength="' + K.esc(s) + '" aria-pressed="' + (s === st.strength) + '">' + K.esc(s) + '</button>';
    }).join('');
    var body = box().querySelector('[data-dvp-body]');
    body.innerHTML =
      '<div class="dvp__head"><div><h2 class="dvp__h" id="dvp-title">Developer for ' + K.esc(current.pair.colour_name || 'your colour') + '</h2>' +
      (showSub() ? '<p class="dvp__sub">' + K.esc(current.copy.sub) + '</p>' : '') + '</div>' +
      '<button type="button" class="dvp__x" data-dvp-close aria-label="Close">✕</button></div>' +
      '<div class="dvp__chips" role="group" aria-label="Strength">' + chips + '</div>' +
      '<div class="dvp__primary">' + group(o.rows(st.strength)) + '</div>';
    body.querySelector('.dvp__primary').style.minHeight = reserve(body, o) + 'px';
    place(body);
  }

  /** Failure of the add itself (never a UI-stage error): reset the row and say why under it. */
  function addFailed(btn, id, reason) {
    delete st.busy[id];
    // `btn` may be detached (a chip click redraws the rows mid-add). Redraw from state - the
    // row comes back with a normal Add - and put the error under the CURRENT row, if it's shown.
    var b = box();
    if (!current || !b || b.hidden) return;
    draw();
    var live = b.querySelector('[data-dvp-add="' + id + '"]');
    var rowEl = live && live.closest && live.closest('.dvp__row');
    if (!rowEl) return;
    var e = rowEl.nextElementSibling;
    if (!e || !e.classList.contains('dvp__err')) {
      e = document.createElement('p'); e.className = 'dvp__err'; e.setAttribute('role', 'alert');
      rowEl.parentNode.insertBefore(e, rowEl.nextSibling);
    }
    e.textContent = reason || 'That could not be added. Please try again.';
  }

  function add(btn) {
    var id = btn.getAttribute('data-dvp-add');
    var qty = st.qty[id] || 1;
    st.busy[id] = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('dvp__add--busy');
    btn.innerHTML = '<span class="dvp__spin" aria-hidden="true"></span><span class="dvp__vh">Adding</span>';
    var payload = { items: [{ id: Number(id), quantity: qty, properties: {
      _dev_upsell: 'popout', _dev_upsell_source: current.colourHandle } }] };
    var d = drawer(), tn = toast();
    var host = tn && tn.getSectionsToRender ? tn : d;
    // Ask for the toast's drawer section in the same round trip (as assets/complements.js does).
    if (host && host.getSectionsToRender) {
      payload.sections = host.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    // Stage (a): the request and Shopify's verdict. Only this stage may report a failure.
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload) })
      .then(function (r) {
        return r.json().then(function (res) { return { ok: r.ok, res: res }; }, function () { return { ok: false, res: null }; });
      })
      .then(function (o) {
        var res = o.res;
        if (!o.ok || !res || res.status) {
          // Shopify's own reason when it gave one; never a JS exception's text.
          addFailed(btn, id, res && res.status ? (res.description || res.message || null) : null);
          return;
        }
        // Stage (b): the line is in. Nothing below may report a failure.
        // The toast repaints to the developer just added (and re-renders the drawer behind it,
        // and runs freeShippMsg). Its cart-notification:open is ignored by onToastOpen() while
        // the pop-out is up, so the Developers button stays until close().
        try {
          var t = toast(), line = res.items && res.items[0];
          if (t && t.renderContents && line) t.renderContents(Object.assign({}, line, { sections: res.sections }));
          else if (d && d.renderContents && res.sections) {
            d.renderContents(res);
            try { if (typeof window.freeShippMsg === 'function') window.freeShippMsg(); } catch (e3) {}
          }
          else document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (e1) {
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e2) {}
        }
        delete st.busy[id];
        if (!current) return;   // closed mid-add: the line is in, nothing left to redraw
        current.addedAny = true;   // close() then retires the Developers button
        try {
          current.inCart[id] = (current.inCart[id] || 0) + qty;
          st.qty[id] = Math.max(1, Math.min(qty, maxOf(id)));
          st.added[id] = true;
          draw();
          refocus('[data-dvp-add="' + id + '"]');
        } catch (e4) {}
      }, function () { addFailed(btn, id, null); });
  }

  function start() {
    // The toast decides the Developers button on every add it shows.
    document.addEventListener('cart-notification:open', onToastOpen);
    // Quantity steps react on pointerdown: a click only fires on release, which reads as lag
    // on a control you tap repeatedly.
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || !e.target || !e.target.closest) return;
      var b = box(); if (!b || b.hidden || !current) return;
      var dq = e.target.closest('[data-dvp-dec]'), iq = e.target.closest('[data-dvp-inc]');
      var btn = dq || iq;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      bump(btn.getAttribute(dq ? 'data-dvp-dec' : 'data-dvp-inc'), dq ? -1 : 1);
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-cn-dev-open]')) { e.preventDefault(); return open(); }
      var b = box(); if (!b || b.hidden || !current) return;
      if (e.target === b || e.target.closest('[data-dvp-close]')) { e.preventDefault(); return close(); }
      // +/- are handled on pointerdown; here only keyboard activation (detail 0).
      var dq = e.target.closest('[data-dvp-dec]');
      if (dq) { if (e.detail === 0 && !dq.disabled) bump(dq.getAttribute('data-dvp-dec'), -1); return; }
      var iq = e.target.closest('[data-dvp-inc]');
      if (iq) { if (e.detail === 0 && !iq.disabled) bump(iq.getAttribute('data-dvp-inc'), 1); return; }
      var s = e.target.closest('[data-dvp-strength]');
      if (s) {
        st.strength = s.getAttribute('data-dvp-strength');
        draw();
        return refocus('[data-dvp-strength="' + st.strength + '"]');
      }
      var a = e.target.closest('[data-dvp-add]');
      if (a && !a.disabled) return add(a);
    });
    document.addEventListener('keydown', function (e) {
      // A stale flag (keyup lost to a blur) must not swallow a later, legitimate Escape keyup.
      if (e.key !== 'Escape' || !e.repeat) escConsumed = false;
      var b = box(); if (!b || b.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); escConsumed = true; close(); return; }
      if (e.key === 'Tab') {
        var f = b.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!b.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, true);
    if (window.addEventListener) window.addEventListener('blur', function () { escConsumed = false; });
    // Swallow the keyup of an Escape we consumed, so no keyup-Escape handler (the drawer's
    // own, should it be open) also acts on the press that closed the pop-out.
    document.addEventListener('keyup', function (e) {
      if (!escConsumed || e.key !== 'Escape') return;
      escConsumed = false;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
